import notice from '@/api/popup'
import request from '@/api/ajax'
import config from '@/api/common';
import _ from 'lodash'
import wtsTools from '@static/js/wtsTools.esm.min.js'
// let tools=wtsTools;
var insureJs = {
    getUnionid: function () {
        //新保保参数相关js
        if (!sessionStorage.getItem('unionid') || sessionStorage.getItem('unionid') == "null") {
            var unionid = tools.getQueryString('unionid');
            sessionStorage.setItem('unionid', unionid);
        } else {
            var unionid = sessionStorage.getItem('unionid')
        }
        if (unionid) {
            return unionid;
        }
    },
    /**
     * 新保保参数处理
     * 0存，1取；
     */
    xbbParamsFn: function (type) {
        var onlyPermium = tools.getQueryString('onlyPermium');
        if (type == 0) {
            if (onlyPermium) {
                sessionStorage.onlyPermium = onlyPermium;
            }
        } else if (type == 1) {
            if (onlyPermium) {
                if (onlyPermium == 2) {
                    notice.alert("根据监管规定，不能直接或间接通过网络平台给与投保人、被保险人、受益人合同约定外的利益，自买单不能投保。");
                    return true;
                } else {
                    return false;
                }
            } else {
                onlyPermium = sessionStorage.onlyPermium;
                if (onlyPermium == 2) {
                    notice.alert("根据监管规定，不能直接或间接通过网络平台给与投保人、被保险人、受益人合同约定外的利益，自买单不能投保。");
                    return true;
                } else {
                    return false;
                }
            }

        }
    },
    /*
    * 银行卡号luhm校验
    * 1.将未带校验位的 15（或18）位卡号从右依次编号 1 到 15（18），位于奇数位号上的数字乘以 2。
    * 2.将奇位乘积的个十位全部相加，再加上所有偶数位上的数字。
    * 3.将加法和加上校验位能被 10 整除。
    * */
    BankCheck: function (bankno) {
        if (!initCheck(bankno)) {
            return false;
        } else {
            return true;
        }
        function luhmCheck(bankno) {
            if (bankno.indexOf('966666') == 0 || bankno.indexOf('621785') == 0) {
                return true;
            }
            var lastNum = bankno.substr(bankno.length - 1, 1); //取出最后一位（与luhm进行比较）
            var first15Num = bankno.substr(0, bankno.length - 1); //前15或18位
            var newArr = new Array();
            for (var i = first15Num.length - 1; i > -1; i--) { //前15或18位倒序存进数组
                newArr.push(first15Num.substr(i, 1));
            }
            var arrJiShu = new Array(); //奇数位*2的积 <9
            var arrJiShu2 = new Array(); //奇数位*2的积 >9
            var arrOuShu = new Array(); //偶数位数组
            for (var j = 0; j < newArr.length; j++) {
                if ((j + 1) % 2 == 1) { //奇数位
                    if (parseInt(newArr[j]) * 2 < 9)
                        arrJiShu.push(parseInt(newArr[j]) * 2);
                    else
                        arrJiShu2.push(parseInt(newArr[j]) * 2);
                } else //偶数位
                    arrOuShu.push(newArr[j]);
            }
            var jishu_child1 = new Array(); //奇数位*2 >9 的分割之后的数组个位数
            var jishu_child2 = new Array(); //奇数位*2 >9 的分割之后的数组十位数
            for (var h = 0; h < arrJiShu2.length; h++) {
                jishu_child1.push(parseInt(arrJiShu2[h]) % 10);
                jishu_child2.push(parseInt(arrJiShu2[h]) / 10);
            }
            var sumJiShu = 0; //奇数位*2 < 9 的数组之和
            var sumOuShu = 0; //偶数位数组之和
            var sumJiShuChild1 = 0; //奇数位*2 >9 的分割之后的数组个位数之和
            var sumJiShuChild2 = 0; //奇数位*2 >9 的分割之后的数组十位数之和
            var sumTotal = 0;
            for (var m = 0; m < arrJiShu.length; m++) {
                sumJiShu = sumJiShu + parseInt(arrJiShu[m]);
            }
            for (var n = 0; n < arrOuShu.length; n++) {
                sumOuShu = sumOuShu + parseInt(arrOuShu[n]);
            }
            for (var p = 0; p < jishu_child1.length; p++) {
                sumJiShuChild1 = sumJiShuChild1 + parseInt(jishu_child1[p]);
                sumJiShuChild2 = sumJiShuChild2 + parseInt(jishu_child2[p]);
            }
            //计算总和
            sumTotal = parseInt(sumJiShu) + parseInt(sumOuShu) + parseInt(sumJiShuChild1) + parseInt(sumJiShuChild2);
            //计算Luhm值
            var k = parseInt(sumTotal) % 10 == 0 ? 10 : parseInt(sumTotal) % 10;
            var luhm = 10 - k;
            if (lastNum == luhm) {
                return true;
            } else {
                return false;
            }
        }
        if (!bankno || bankno.length < 16) return;
        /**
         *
         * 1.长度校验
         * 2.数字校验
         * 3.luhn校验或者visa卡，万事达卡校验
         */
        function initCheck(code) {
            // 1.长度校验
            if (code.length < 15 || code.length > 19) {
                // notice.msg('银行卡号长度必须在16到19之间')
                return false;
            }
            var num = /^\d*$/; // 2.数字校验
            if (!num.exec(bankno)) {
                // notice.msg('银行卡号必须全为数字')
                return false;
            }
            var firstNum = code.substr(0, 1);
            // luhn校验或者visa卡，万事达卡校验
            if (firstNum == 4) {
                console.log("visa卡");
                return true;
            } else if (firstNum == 5) {
                console.log("Master卡");
                return true;
            } else if (!luhmCheck(code)) {
                return false;
            }
            return true;
        }
    },
    /*
    * 获取银行信息接口
    * */
    bank_ajax: function (num, callBack, id) {
        if (!num) return;
        var self = this;
        var bankList = {
            type: "post",
            url: "/tools/api/getBankInfo",
            data: {
                cardNumber: num
            },
            dataType: 'json',
            success: function (data, isError) {
                console.log(data)
                if (!isError) {
                    return $("#accountNumber .from-right").attr("data-check", 2);
                }
                if (data.httpCode == 200) {
                    //判断是否为信用卡，接口字段有时会改变，无语
                    if (data.data.binValidateMsg.cardType == "CC") {
                        notice.msg('暂不支持信用卡，请填写您的储蓄卡号码')
                        return $("#accountNumber .from-right").attr("data-check", 2);
                    }
                    return callBack(data.data, num, id); //下拉框识别银行
                } else {
                    console.log("银行卡发送返回失败")
                }
            },
            error: function (xhr, type, errorThrown) {
                //异常处理；
                console.log(type);
            }
        }
        request(bankList);
    },
    /*
    * 获取银行信息接口
    * */
    bank_ajax2: function (params, callBack) {
        if (!params.val) return;
        request({
            type: "post",
            url: "/tools/api/getBankInfo",
            data: {
                cardNumber: params.val
            },
            dataType: 'json',
            success: function (data, isError) {
                console.log(data)
                if (!isError) {
                    return callBack('', params); //下拉框识别银行

                }
                callBack(data.data, params); //下拉框识别银行
            },
            error: function (xhr, type, errorThrown) {
                //异常处理；
                console.log(type);
            }
        })
    },

    reuseDataStorages: function (data, id, value) {
        //储存历史数据
        data[id] = value; //每次内容发生改变，都要保存到reuseData中
        sessionStorage.setItem('reuseData', JSON.stringify(data));
        return data;
    },
    saveCache(data, callback) {
        // 存服务器缓存封装
        request({
            url: '/tools/caculate/api/save',
            data: data,
        }).then((r) => {
            if (callback) callback(r.data)
        }).catch((err) => {
            console.log(err);
        })
    },
    getCache(step, key, data) {
        var url = `/insure/insureProcess?step=${step}&insureUniqueId=${key}`
        if (config.channel == "SHORT") {
            url = `/api/insure/process?step=${step}&insureUniqueId=${key}`
        }
        // 取服务器缓存封装
        return request({
            // href: `http://192.168.32.246:3000/mock/116/api/insure/process`,
            url: url,
            data: data || {},
        })
    },
    IPURouter(step, key, data) {
        // 取服务器缓存封装
        this.getCache(step, key, data).then(e => {
            location.href = e.data.data.url;
        })
    },
    getPayments(type) {
        if (!type) return '';
        const paymentType = {
            'M': "月",
            'Y': "年",
            'D': "",//趸交
            'G': "季",
            'B': "半年",
            'N': "",
        };
        return paymentType[type];
    },
    /**
     * 获取用户环境信息
     */
    getChannel() {
        var channel = wtsTools.tools.getQueryString('wtsChannel');
        if (channel) return channel;
        if (wtsTools.tools.isWtsNativeApp()) {
            return "app_wtsbxw"
        }
        return "";
    },
    // 初始化数据结构
    initModuleData(data, path) {
        path = path || "";
        data.forEach((item, i) => {
            let pathChild = path;
            pathChild += `[${i}]`;
            if (item.moduleCode && item.children && item.children.length > 0) {
                item.elementPath = pathChild;
                pathChild += `.children`;
                if (!_.isBoolean(item.show)) {
                    item.show = true;
                }
                item.children = this.initModuleData(item.children, pathChild);
            } else if (item.moduleCode) {
                item.elementPath = pathChild;
                pathChild += `.data`;
                if (!_.isBoolean(item.show)) {
                    item.show = true;
                }
                if (item.data) {
                    item.data = this.initModuleData(item.data, pathChild);
                }
            } else if (item.elementCode) {
                item.errorMsg = item.errorMsg || "";
                item.elementValue = item.elementValue || "";
                if (!_.isBoolean(item.show)) {
                    item.show = true;
                }
                item.elementPath = pathChild;
            }
        });
        return data;
    },
    // 获取表单校验结果
    getFromValues(data) {
        var result = {};
        data.forEach(item => {
            if (item.children && item.children.length > 0 && item.show) {
                let children = []
                item.children.forEach((child, n) => {
                    let childData = this.getFromValues(child.data);
                    if (childData) {
                        childData.moduleCode = child.moduleCode
                        children.push(childData);
                    }
                })
                result[item.moduleCode] = children;
            } else if (item.data && item.show) {
                result[item.moduleCode] = this.getFromValues(item.data);
            } else if (item.elementCode && item.elementValue && item.show) {
                result[item.elementCode] = item.elementValue;
            }
        });
        if (_.isEmpty(result)) {
            result = null
        }
        return result;
    },
    // 校验type是否是需充填内容类型
    checkTypeUse(type) {
        let blanks = ['5', '12', '25', '27', '40'];
        return blanks.indexOf(type) == -1
    },
    // 校验表单是否完成
    checkFromValues(data, parent) {
        let result = { result: true };
        let blanks = ['5', '12', '25', '27', '40'];
        for (let k = 0; k < data.length; k++) {
            let item = data[k];
            if (item.children && item.children.length > 0 && item.show) {
                let childremResult = this.checkFromValues(item.children);
                if (!childremResult.result) {
                    result = childremResult
                    break;
                }
            } else if (item.data && item.data.length > 0 && item.show) {
                let childremResult = this.checkFromValues(item.data, item);
                if (!childremResult.result) {
                    result = childremResult
                    break;
                }
            } else if (item.elementCode && item.errorMsg && item.show) {
                result.result = false;
                item.parentName = parent.moduleName
                item.parentCode = parent.moduleCode
                result.item = item;
                break;
            } else if (item.elementCode && !item.notNeedFill && !item.elementValue && !_.isNumber(item.elementValue) && item.show && blanks.indexOf(item.elementType) == -1) {
                result.result = false;
                item.parentName = parent.moduleName
                item.parentCode = parent.moduleCode
                result.item = item;
                break;
            }
            else if(item.elementType=='32'&&(!item.elementValue.tell||!item.elementValue.very)){
                result.result = false;
                item.parentName = parent.moduleName
                item.parentCode = parent.moduleCode
                result.item = item;
                break;
            }
        }
        return result;
    },
    // 提示报错信息
    showFromErr(item) {
        let names = item.parentName + "_" + item.elementName + "：";
        if(!item.parentName){
            names = item.elementName + "：";
        }
        if (item.errorMsg) {
            notice.alert(names + item.errorMsg);
        }
        else if(item.elementType=='32'&&item.elementValue){
            if(!item.elementValue.tell){
                names = item.parentName + "_手机号：";
                notice.alert(names + '还没有填写！');
            }
            else if(!item.elementValue.very){
                names = item.parentName + "_验证码：";
                notice.alert(names + '还没有填写！');
            }
        }
        else if (!item.elementValue) {
            notice.alert(names + '还没有填写！');
        }
    },
    getFromData(data, code, moduleCode) {
        let result;
        for (let k = 0; k < data.length; k++) {
            let item = data[k];
            if (item.moduleCode && moduleCode && item.moduleCode == moduleCode) {
                if (item.children) {
                    result = this.getFromData(item.children, code)
                } else if (item.data) {
                    result = this.getFromData(item.data, code)
                }
                if (result) break;
            } else if (item.moduleCode && !moduleCode) {
                if (item.children) {
                    result = this.getFromData(item.children, code)
                } else if (item.data) {
                    result = this.getFromData(item.data, code)
                }
                if (result) break;
            } else if (item.elementCode && item.elementCode == code) {
                result = item
                break;
            }
        }
        return result
    },
    // 流程跳转
    processRoute(self, step, insureUniqueId, data) {
        let route = self.$process.getProcess(step);
        if (route.type == 1) {
            self.$router.push({
                name: route.route,
                params: {
                    key: insureUniqueId,
                },
            });
        } else if (route.type == 2) {
            location.href = data.data.payUrl;
        } else if (route.type == 3) {
            this.getCache(step, insureUniqueId)
                .then((r) => {
                    if (r.data.data.payUrl) {
                        location.href = r.data.data.payUrl;
                    }
                })
                .catch((err) => { });
        }

    }
}

export default insureJs

